module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"head":{"meta":{"description":"TODO:このページの説明文をここに記述する(※Googleの検索結果に表示されるのでよく考える事!)"}},"message":{"search_prefix":"No result","search_unit":" ","detail":"Your search did not match any documents.","change_contidtion":"Try different keywords."}}}')
  delete Component.options._Ctor
}
